var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hp-manager-dialog"},[_c('a-modal',{attrs:{"centered":"","title":_vm.title,"top":_vm.top,"width":_vm.width,"footer":null,"visible":_vm.visiable},on:{"cancel":_vm.cancel,"update:visible":function($event){_vm.visiable=$event}}},[(_vm.visiable)?_vm._t("slot"):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13df688f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/modal.vue
// module id = null
// module chunks = 